import { Alert, Button, Portal, Snackbar } from "@mui/material";
import { useTranslation } from "i18n-fe";

// Card #3614: the "Over-time prompt" (GLOSSARY.md). A warning on the tablet at
// judge position C when the bell-to-entry timer runs out. It belongs to the
// scribe's own action (they are the one who presses In Ring), so it lives here
// and nowhere else: not an active alert, no other screen renders it. It is a
// non-modal banner, never a dialog, so scoring is never blocked; acknowledging
// dismisses it and does NOT stop the timer.
//
// It is mounted through a Portal onto document.body: ScoringForm renders it from
// inside the sticky timer row, whose stacking context otherwise puts a fixed
// banner BEHIND the sticky session header (real-Chrome shots at 768 and 1024
// wide showed the message clipped and the Acknowledge button hidden). Anchored
// at the top, above the timer row, it never covers In Ring / Pause / Restart.
export default function OverTimePrompt({ open, limitSeconds, onAcknowledge }) {
  const { t } = useTranslation("score");
  return (
    <Portal>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="warning"
          variant="filled"
          data-testid="over-time-prompt"
          sx={{
            fontSize: "1.25rem",
            fontWeight: 600,
            alignItems: "center",
            boxShadow: 6,
            width: "min(640px, calc(100vw - 32px))",
          }}
          action={
            <Button
              color="inherit"
              variant="outlined"
              size="large"
              sx={{
                minHeight: 48,
                minWidth: 112,
                whiteSpace: "nowrap",
                fontWeight: 700,
              }}
              data-testid="over-time-prompt-ack"
              onClick={onAcknowledge}
            >
              {t("scoring.overTimeAcknowledge")}
            </Button>
          }
        >
          {t("scoring.overTimeMessage", { seconds: limitSeconds })}
        </Alert>
      </Snackbar>
    </Portal>
  );
}
